import React from 'react';
import cn from 'classnames';
import BasketRecap from './recap';
import BasketContent from './basket_content';
import {hasTickets} from './basket_utils';
import Portal from '../../common/portal';

export default class Basket extends React.Component {
  static propTypes = {
    basket: React.PropTypes.object
  };

  render () {
    const {basket} = this.props;
    const basketHasTickets = hasTickets(basket);

    if (!basketHasTickets) {
      return false;
    }
    const containerClass = cn({
      'basket': true,
      'is-active': basketHasTickets
    });

    return (
      <Portal isOpen>
        <div className={containerClass} data-component="basket">
          <BasketRecap
            isActive={basketHasTickets}
            {...basket}
            isExpanded={basket.showTickets} />
          <BasketContent {...this.props} />
        </div>
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/index.js